export default "__VITE_ASSET__6fceb331__"